module.exports = __webpack_public_path__ + "static/media/withsamsonbuddy.fe3e4330.jpeg";